import { motion, useSpring, useTransform } from 'framer-motion';
import { memo, useEffect, useRef } from 'react';

interface AnimatedNumberProps {
  value: number;
  duration?: number;
  formatOptions?: Intl.NumberFormatOptions;
}

export const NumberScroll = memo(({ value, duration = 0.8, formatOptions }: AnimatedNumberProps) => {
  const prevValueRef = useRef<number>(value);

  const spring = useSpring(prevValueRef.current, {
    mass: 0.8,
    stiffness: 75,
    damping: 15,
    duration,

    restDelta: 0.1,
  });

  const display = useTransform(spring, (current) => {
    return new Intl.NumberFormat(undefined, formatOptions).format(Math.round(current));
  });

  useEffect(() => {
    if (prevValueRef.current !== value) {
      spring.set(value);
      prevValueRef.current = value;
    }
  }, [spring, value]);

  return <motion.span>{display}</motion.span>;
});

NumberScroll.displayName = 'NumberScroll';
